// src/components/layout/sectionFrames.tsx
//
// Section chrome as a `SectionFrame` (see ProtectedRoute): the same sidebar
// + content area each section's pages render themselves, so a route guard can
// draw a denial inside it and the reader keeps the section menu.
//
// Insights has a wrapper of its own already: pass `InsightsSectionLayout`.

import type { ReactNode } from "react";
import AppLayout from "@/layout/AppLayout";
import ChatLayoutMantine from "@/layout/ChatLayoutMantine";
import SettingsSidebar from "@/components/settings/SettingsSidebar";
import DataManagementSidebar from "@/components/data-management/DataManagementSidebar";

export function SettingsFrame({ children }: { children: ReactNode }) {
  return <AppLayout sidebar={<SettingsSidebar />}>{children}</AppLayout>;
}

export function DataManagementFrame({ children }: { children: ReactNode }) {
  return (
    <ChatLayoutMantine sidebarType="data-management" sidebar={<DataManagementSidebar />}>
      {children}
    </ChatLayoutMantine>
  );
}
